var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSerialNumber = function SvgSerialNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#serial-number_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 16a4.9 4.9 0 1 0 9.8 0 4.9 4.9 0 0 0-9.8 0M23.5 23l-3.535-3.535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19H3.9a1.4 1.4 0 0 1-1.4-1.4v-10a1.4 1.4 0 0 1 1.4-1.4h14a1.4 1.4 0 0 1 1.4 1.4v.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.848 6.57-2.633-3.947A1.4 1.4 0 0 0 15.053 2H6.747a1.4 1.4 0 0 0-1.165.623l-2.63 3.948M10.9 2v4.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "serial-number_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgSerialNumber;